import { render, staticRenderFns } from "./CostPricesManagement.vue?vue&type=template&id=d50fb892"
import script from "./CostPricesManagement.vue?vue&type=script&lang=js"
export * from "./CostPricesManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports